function initCarousels() {

  if ($('.product-carousel').length && !$('.product-carousel').hasClass('owl-loaded')) {
    $('.product-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  }

  if ($('.testimonial-carousel').length && !$('.testimonial-carousel').hasClass('owl-loaded')) {
    $('.testimonial-carousel').owlCarousel({
      loop: true,
      margin: 60,
      nav: false,
      dots: false,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  }

  if ($('.home-collection-carousel').length && !$('.home-collection-carousel').hasClass('owl-loaded')) {
    $('.home-collection-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 2 },
        600: { items: 2 },
        1200: { items: 3 }
      }
    });
  }

  if ($('.product-gallery.owl-carousel').length && !$('.product-gallery').hasClass('owl-loaded')) {
    $('.product-gallery.owl-carousel').owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 }
      }
    });
  }

  if ($('.comp-carousel').length && !$('.comp-carousel').hasClass('owl-loaded')) {
    $('.comp-carousel').owlCarousel({
      items: 2,
      loop: true,
      margin: 10,
      nav: true,
      dots: true,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  }

  if ($('.drawer-carousel').length && !$('.drawer-carousel').hasClass('owl-loaded')) {
    $('.drawer-carousel').owlCarousel({
      items: 1,
      loop: true,
      margin: 10,
      nav: true,
      dots: true,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 }
      }
    });
  }

  if (window.innerWidth < 768) {
    if ($('.ingredients-carousel').length && !$('.ingredients-carousel').hasClass('owl-loaded')) {
      $('.ingredients-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        items: 1
      });
    }
  }

  $(document).on('change', '.variant-select', function() {
    var price = $(this).find(':selected').data('price');
    $(this).closest('.item').find('.variant-price').text(price);
  });
}

// $('.add-to-cart-btn').click(function(){
//   $('.drawer').addClass('active');
// })


$('.card-coll-title').click(function () {
  $(this).closest('.collection-list__item').find('.ingredient-list').toggleClass('active');
});


// collection variant price js
  document.addEventListener('DOMContentLoaded', function () {
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(function(card) {
      const select = card.querySelector('.variant-select');
      const priceEl = card.querySelector('.var-coll-price');

      select.addEventListener('change', function() {
        const selectedOption = select.options[select.selectedIndex];
        const price = selectedOption.getAttribute('data-price');
        priceEl.textContent = price;
      });
    });
  });

  // ========= Related product js
function initRelatedProductsCarousel() {
  var $carousel = $('.related-products-carousel');

  if ($carousel.length && !$carousel.hasClass('owl-loaded')) {
    $carousel.owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 1 },
        1000: { items: 1 },
        1400: { items: 1 }
      }
    });
  }
}





// Use a MutationObserver to detect when Shopify inserts recommendations
document.addEventListener('DOMContentLoaded', function () {
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if ($(mutation.target).find('.related-products-carousel').length) {
        initRelatedProductsCarousel();
      }
    });
  });

  document.querySelectorAll('product-recommendations').forEach(function (el) {
    observer.observe(el, { childList: true, subtree: true });
  });
});

// Initial load
document.addEventListener('DOMContentLoaded', initCarousels);


// Also run inside Shopify editor
document.addEventListener('shopify:section:load', initRelatedProductsCarousel);

// Shopify editor / section reload
document.addEventListener('shopify:section:load', initCarousels);

// Product video

$('#video-poster').click(function(){
    $(this).css({"display": "none", "opacity": "0"});
    $('#video').get(0).play(); 
});

$('#video').on('ended',function(){
	 $("#video-poster").css({"display": "block", "opacity": "1"});
});

// Nutrition Facts
$('.nf-dropdown').on('click', function(){
  $(this).find('ul').toggleClass('open');
  $(this).toggleClass('active');
});

// function updateFreeShippingMessage(cart) {
//   const threshold = 50; // free shipping threshold in dollars
//   const cartTotal = cart.total_price / 100; // convert cents to dollars
//   const messageEl = document.querySelector(".message");

//   if (!messageEl) {
//     const msg = document.createElement("p");
//     msg.classList.add("message");
//     document.querySelector(".cart-drawer__footer")?.prepend(msg);
//   }

//   const updatedMessage = cartTotal >= threshold
//     ? "Congrats! You’ve unlocked FREE SHIPPING!"
//     : `You are $${(threshold - cartTotal).toFixed(2)} away from FREE SHIPPING!`;

//   document.querySelector(".message").textContent = updatedMessage;
// }

// // Watch for cart updates
// document.addEventListener("cart:updated", function (event) {
//   updateFreeShippingMessage(event.detail.cart);
// });

// // Initial load
// fetch("/cart.js")
//   .then(res => res.json())
//   .then(cart => updateFreeShippingMessage(cart));



//   // Listen for Shopify cart form submissions
// document.addEventListener('click', function (event) {
//   if (event.target.closest('[name="add"]') || event.target.closest('.cart-remove-button')) {
//     setTimeout(updateCartDrawer, 300); // small delay to let Shopify process
//   }
// });

// function updateCartDrawer() {
//   fetch('/?section_id=CartDrawer')
//     .then((response) => response.text())
//     .then((html) => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');
//       const newDrawer = doc.querySelector('#CartDrawer');

//       if (newDrawer) {
//         const cartDrawer = document.querySelector('#CartDrawer');
//         cartDrawer.innerHTML = newDrawer.innerHTML;
//       }
//     })
//     .catch((err) => console.error('Error updating cart drawer:', err));
// }


// document.addEventListener("DOMContentLoaded", function () {
//   const drawer = document.querySelector('.drawer__inner-empty');

//   if (drawer) {
//     const observer = new MutationObserver(() => {
//       // check if carousel exists inside empty drawer
//       const carousel = drawer.querySelector('.drawer-carousel');

//       if (carousel && !$(carousel).hasClass('owl-loaded')) {
//         $(carousel).owlCarousel({
//           items: 1,
//           loop: true,
//           margin: 10,
//           nav: true,
//           dots: true,
//           responsive: {
//             0: { items: 1 },
//             600: { items: 1 },
//             1000: { items: 1 }
//           }
//         });
//       }
//     });

//     // watch for changes inside the empty drawer
//     observer.observe(drawer, { childList: true, subtree: true });
//   }
// });


// jQuery(document).ready(function($){
//   // Get the left offset of the first container
//   var containerLeft = $('.choices-sec.pro-choice .page-width').offset().left;

//   // Apply the same left spacing to section two
//   $('.nutrition-facts').css('padding-left', containerLeft + 'px');
// });
// jQuery(document).ready(function($){
//   function alignSectionTwo() {
//     var containerLeft = $('.choices-sec .page-width').offset().left;
//     $('.nutrition-facts').css('padding-left', containerLeft + 'px');
//   }

//   alignSectionTwo(); // run on load
//   $(window).resize(alignSectionTwo); // run on resize
// });

jQuery(document).ready(function($){
  function alignSectionTwo() {
    // Get the padding-left of .page-width
    var containerPadding = $('.customer-testimonial .page-width').first().css('padding-left');
    
    // Apply that as left padding to the target section
    $('.nutrition-facts .nf-body').css('padding-left', containerPadding);
  }

  alignSectionTwo(); // run on load
  $(window).resize(alignSectionTwo); // run on resize
});


//  product recent viewed js vikash
 

 



// function initEmptyCartCarousel() {

//  console.log(' inside drawer-carousel function');
//   $('.drawer-carousel').owlCarousel({
//     items: 1,
//     loop: true,
//     margin: 10,
//     nav: true,
//     dots: true,
//     responsive:{
//       0:{ items:1 },
//       600:{ items:1 },
//       1000:{ items:1 }
//     }
 
// });
// }

// function toggleEmptyCartCarousel(itemCount) {
//   var $drawerEmptyCarousel = $('#drawer-empty-carousel');

//   if (!$drawerEmptyCarousel.length) return;

//   if (itemCount === 0) {
//     console.log(' inside drawer-carousel : itemCount === 0');
//     $drawerEmptyCarousel.removeClass('hidden');
//     initEmptyCartCarousel();  
//   } else {
//     $drawerEmptyCarousel.addClass('hidden');
//         console.log('addClass hidden');

//   }
// }

// // Run on first page load
// $(document).ready(function() {
//   initEmptyCartCarousel();
//        console.log('load document');
// });

// // Listen for Shopify drawer/cart updates
// document.addEventListener('cart:updated', function(event) {
//    console.log('cart:updated');
//   if (event.detail && event.detail.cart) {
//   console.log('cart:updated event.detail');
//     toggleEmptyCartCarousel(event.detail.cart.item_count);
//   }
// });

// // Fallback for AJAX responses
// $(document).on('ajaxComplete', function(event, xhr, settings) {
//   if (settings.url.includes('/cart')) {
//      console.log('url /cart');
//     try {
//            console.log('url /cart try');
//       var cart = JSON.parse(xhr.responseText);
//       if (cart && typeof cart.item_count !== 'undefined') {
//         toggleEmptyCartCarousel(cart.item_count);
//       }
//     } catch (e) {
//            console.log('url /cart catch');
//       initEmptyCartCarousel();
//     }
//   }
// });
// document.addEventListener("DOMContentLoaded", function() {
//   ["cart:updated", "cart:change", "cart:refresh"].forEach(evt => {
//     document.addEventListener(evt, function(e) {
//       console.log("Event fired:", evt, e.detail);
//     });
//   });
// });


$(document).ready(function(){
            $(".accordion-titel").click(function(){
              $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
              $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
              $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
            });
          });

          $(document).ready(function () {
            $(".accordion-item").click(function () {
              $(this).toggleClass("active");
              $(this).siblings().removeClass("active");
            });
          });




          